import { render } from "./lottie.vue?vue&type=template&id=5baf586c"
import script from "./lottie.vue?vue&type=script&lang=js"
export * from "./lottie.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Desktop/projNii/ERP/rada-erp-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__